import React, { useEffect, useState, lazy } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const testimonialImages = ['https://cdn.magicpatterns.com/uploads/jU2psEMqBfgAvLKtg2Bhc5/1.png', 'https://cdn.magicpatterns.com/uploads/fGinUBiTa5rRZwfS3397Tu/2.png', 'https://cdn.magicpatterns.com/uploads/7e7ZB99qEiaupboicFWGni/3.png'];
export function TestimonialsSection() {
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % testimonialImages.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
  const goPrev = () => setCurrent(prev => (prev - 1 + testimonialImages.length) % testimonialImages.length);
  const goNext = () => setCurrent(prev => (prev + 1) % testimonialImages.length);
  return <section className="py-12 md:py-16 px-4 bg-[#2E0640] mt-[-15px] mb-[-15px] pt-[40px] pb-[40px]" data-id="element-338">
      <div className="max-w-2xl mx-auto" data-id="element-339">
        <h2 className="md:text-5xl font-black text-white text-center text-[32px] pt-[-px] pb-[-px] mt-[0px] mb-[0px]" data-id="element-340">
          Testimonios de nuestros alumnos👇🏻
        </h2>
        <p className="text-xl text-gray-300 text-center pt-[15px] pb-[15px] mt-[0px] mb-[0px]" data-id="element-341">
          Empezaron desde cero, sin conocimientos, sin salir en cámara y ya
          están vendiendo💰
        </p>

        <div className="relative" data-id="element-342">
          <div className="overflow-hidden rounded-2xl border-2 border-[#FC9DFF] shadow-xl" data-id="element-343">
            <div className="flex transition-transform duration-500 ease-in-out" style={{
            transform: `translateX(-${current * 100}%)`
          }} data-id="element-344">
              {testimonialImages.map((img, index) => <img key={index} src={img} alt={`Reseña de alumno ${index + 1}`} loading="lazy" className="w-full flex-shrink-0 h-auto object-cover pt-[0px] pb-[0px] mt-[0px] mb-[0px]" data-id="element-345" />)}
            </div>
          </div>

          <button onClick={goPrev} className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors" data-id="element-346">
            <ChevronLeftIcon className="w-5 h-5" data-id="element-347" />
          </button>
          <button onClick={goNext} className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors" data-id="element-348">
            <ChevronRightIcon className="w-5 h-5" data-id="element-349" />
          </button>
        </div>

        <div className="flex justify-center gap-2 mt-4" data-id="element-350">
          {testimonialImages.map((_, index) => <button key={index} onClick={() => setCurrent(index)} className={`w-2.5 h-2.5 rounded-full transition-all ${current === index ? 'bg-[#FC9DFF] scale-125' : 'bg-gray-500 hover:bg-gray-400'}`} data-id="element-351" />)}
        </div>

        <div className="space-y-4 mt-8" data-id="element-352">
          {['https://cdn.magicpatterns.com/uploads/85qgfu2wtYmbqYexFLdpZH/testimonio_1.png', 'https://cdn.magicpatterns.com/uploads/csZrZy8g2Q3smbV6qHtbh6/testimonio_2.png', 'https://cdn.magicpatterns.com/uploads/3JtrzgseguPSHtPVBwRRrZ/testimonio_3.png', 'https://cdn.magicpatterns.com/uploads/vcXuqTU2nu2545pGkLnkWL/testimonio_4.png', 'https://cdn.magicpatterns.com/uploads/sBxY6HKwfN5w4J5ej2XHUG/testimonio_5.png', 'https://cdn.magicpatterns.com/uploads/7XYTwtqVzMcpDr4yAYGfCe/testimonio_6.png', 'https://cdn.magicpatterns.com/uploads/nDJ5W9Cr6nR8ztqfEtEqFN/testimonio_7.png', 'https://cdn.magicpatterns.com/uploads/7dvAKMpTgypFhgkZQb2x8L/testimonio_8.png'].map((img, index) => <img key={index} src={img} alt={`Testimonio adicional ${index + 1}`} loading="lazy" className="w-full rounded-2xl shadow-xl" data-id="element-353" />)}
        </div>
      </div>
    </section>;
}